import { EditorStatus } from "../../../../types/EditorStatus";
import {
  EditorActionKey,
  NotebookActionKey,
} from "../../../actions/ActionKeys";
import { EditorAction } from "../../../actions/editor";
import { NotebookAction } from "../../../actions/notebook";

const DEQUEUED_STATES = [
  EditorStatus.RUNNING,
  EditorStatus.STOPPED,
  EditorStatus.ERROR,
  EditorStatus.FATAL,
];

export const queuePosition = (
  state: number | null = null,
  action: NotebookAction | EditorAction
): number | null => {
  switch (action.type) {
    case NotebookActionKey.SET_QUEUE_POSITION:
      return action.payload.position;
    case EditorActionKey.SET_EDITOR_STATUS:
      if (DEQUEUED_STATES.includes(action.payload.status)) {
        return null;
      }
      return state;
    default:
      return state;
  }
};
